module.exports = __webpack_public_path__ + "static/media/noImage.5c8eece6.png";